export class CustomFieldResponse {
    results?: (CustomField)[] | null;
}

export class CustomField {
    fieldId: number;
    clientEditable: number;
    dataType: number;
    defaultValue: string;
    dscEnable: number;
    description: string;
    displayName: string;
    fieldType: number;
    inputValidation: number;
    inputMask: string;
    userMask: string;
    required: number;
    valueType: number;
    dateFormat: string;
    customEntry: (CustomEntryList)[] | null;
}

export class CustomEntryList {
    id: number;
    displayName: string;
    name: string;
}
